const module = {
  config: {
    name: 'summary',
    icon: 'ri-map-line',
    desc: 'PMIS Infrastruktur II',
    layout: true
  },
  routes: [
    { name: 'summary-dahsboard', label: 'Dashboard Summary', icon: null, path: '/summary-dahsboard', component: () => import('./summary-map.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/summary/_index.js